import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { STUDIO_DOC_TITLE } from "../constants/Studio.constants.js";
import { UNIFIED_DOC_TITLE } from "../constants/Unified.constants.js";
import { GateState } from "../models/expapiunified/Gate.model.js";
const variantText = () => EnvironmentService.isUnifiedView ? "Variant" : "Flight";
const featureFlagText = () => EnvironmentService.isUnifiedView ? "Flag" : "Gate";
const flightingText = () => EnvironmentService.isUnifiedView ? "Experiment" : "Flighting";
const getDocTitle = () => EnvironmentService.isUnifiedView ? UNIFIED_DOC_TITLE : STUDIO_DOC_TITLE;
const showVNextProgressionPage = (isVNext) => EnvironmentService.showDifferentProgressionFeaturesOnVNext() ? EnvironmentService.isUnifiedView && !!isVNext : EnvironmentService.isUnifiedView;
const isStepNew = (step) => !step.startedAt && !step.stoppedAt;
const isStepRunning = (step) => !!step.startedAt && !step.stoppedAt;
const isStepStopped = (step) => !!step.startedAt && !!step.stoppedAt;
const isGateUnlocked = (gate) => gate.state === GateState.Approved;
export {
  featureFlagText,
  flightingText,
  getDocTitle,
  isGateUnlocked,
  isStepNew,
  isStepRunning,
  isStepStopped,
  showVNextProgressionPage,
  variantText
};
//# sourceMappingURL=UnifiedViewUtils.js.map
